import { diContainer, serviceNames } from '../../diContainer/diContainer';
import Address from '../../domain/entities/Address';
import TransactionRepository from '../../repositories/TransactionRepository';
import { DeliveryOptions, FIELD_TYPE } from '../../constants/Constants';
import ValidateAndSubmitAddressesUseCase from '../ValidateAndSubmitAddressesUseCase';
import ShippingRepository from '../../repositories/ShippingRepository';

class UseRecommendedUpsAddressUseCase {
  private userAddress: Address;

  private upsAddress: Address;

  private isBillingSameAsShipping: boolean;

  private deliveryOption: DeliveryOptions;

  private transactionRepository: TransactionRepository;

  private shippingRepository: ShippingRepository;

  constructor(
    userAddress: Address,
    upsAddress: Address,
    isBillingSameAsShipping: boolean,
    deliveryOption: DeliveryOptions,
  ) {
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.userAddress = userAddress;
    this.upsAddress = upsAddress;
    this.isBillingSameAsShipping = isBillingSameAsShipping;
    this.deliveryOption = deliveryOption;
    this.shippingRepository = diContainer.get(serviceNames.shippingRepository);
  }

  public execute = async (): Promise<void> => {
    const { setValues } = this.shippingRepository.formStore;

    const transaction = await this.transactionRepository.getTransaction();
    // Replace user input with UPS suggestions.
    this.userAddress.id = transaction.shippingAddress.id;
    this.userAddress.updateAttributes({
      [FIELD_TYPE.CITY]: this.upsAddress.attributes[FIELD_TYPE.CITY],
      [FIELD_TYPE.FIRST_LINE_ADDRESS]: this.upsAddress.attributes[FIELD_TYPE.FIRST_LINE_ADDRESS],
      [FIELD_TYPE.STATE]: this.upsAddress.attributes[FIELD_TYPE.STATE],
      [FIELD_TYPE.ZIPCODE]: this.upsAddress.attributes[FIELD_TYPE.ZIPCODE],
    });

    if (!transaction.user.isUserRegistered) {
      // for guest simply updating the form values will suffice
      setValues({
        [FIELD_TYPE.CITY]: this.upsAddress.attributes[FIELD_TYPE.CITY],
        [FIELD_TYPE.FIRST_LINE_ADDRESS]: this.upsAddress.attributes[FIELD_TYPE.FIRST_LINE_ADDRESS],
        [FIELD_TYPE.STATE]: this.upsAddress.attributes[FIELD_TYPE.STATE],
        [FIELD_TYPE.ZIPCODE]: this.upsAddress.attributes[FIELD_TYPE.ZIPCODE],
      });
    } else {
      // for registered user, we still need to update a selected address
      return new ValidateAndSubmitAddressesUseCase({
        deliveryOption: this.deliveryOption,
        isBillingSameAsShipping: this.isBillingSameAsShipping,
        shippingAddress: this.userAddress,
        withUpsValidation: false,
      }).execute();
    }
  };
}

export default UseRecommendedUpsAddressUseCase;
